import React from "react";
import { useNavigate } from "react-router-dom";
import checkchallanImage from "../../assets/challan-online.png";
import indIcon from "../../assets/Ind.png";
import styles from "./CarServiceReport.module.css";
import OurPartners from "../../components/OurPartners";
import ServiceHistoryRisksSection from "./ServiceHistoryRisksSection";
import ServiceBenifits from "./ServiceBenifits";
import FAQService from "./FAQService";

function CarServiceReport() {
  const navigate = useNavigate();

  return (
    <div className={styles.mainContainer}>
      <div className={styles.container}>
        {/* Left Content */}
        <div className={styles.leftContent}>
          <h1 className={styles.title}>
            Service History Starting at Just{" "}
            <span className={styles.highlight}>₹299</span>
          </h1>

          {/* Input Box */}
          <div className={styles.searchBox}>
            <div className={styles.searchContainer}>
              <div className={styles.prefix}>
                <img src={indIcon} alt="IND" />
              </div>
              <input
                type="text"
                placeholder="MH 15 CV 2211"
                defaultValue="MH 15 CV 2211"
                className={styles.searchInput}
              />
            </div>
            <button
              className={styles.getReportButton}
              onClick={() => navigate("/CarServiceReportDetails")}
            >
              Get Report
            </button>
          </div>

          <div className={styles.sampleReportLink}>
            <span className={styles.linkIcon}>📄</span>
            <span className={styles.linkText}>View Sample report</span>
          </div>
        </div>

        {/* Right Image */}
        <div className={styles.rightContent}>
          <div className={styles.imageWrapper}>
            <div className={styles.blueCircle}></div>
            <img
              src={checkchallanImage}
              alt="Illustration"
              className={styles.image}
            />
          </div>
        </div>
      </div>

      <ServiceHistoryRisksSection />
      <ServiceBenifits />
      <FAQService />
      <OurPartners />
    </div>
  );
}

export default CarServiceReport;
